import type {ReactElement} from 'react';
import React from 'react';
import type {AiPromptBoxTemplatesTooltipProps} from './ai-prompt-box-templates-tooltip.types';
import styles from './ai-prompt-box-templates-tooltip.module.scss';
import {Text} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import {Popover} from '@Components/popover';
import {PopoverDefaultAlignment} from '@Components/popover/popover.types';

export function AiPromptBoxTemplatesTooltip({referenceElementRef, onClose}: AiPromptBoxTemplatesTooltipProps): ReactElement {
  return (
    <Popover
      referenceElementRef={referenceElementRef}
      popoverCloseFunction={onClose}
      alignment={PopoverDefaultAlignment.BOTTOM_CENTER}
      hasArrow
      staticOffsetForArrow={null}
      hasAutoPlacement={false}
      className={styles.tooltipPopover}
    >
      <div className={styles.tooltipContent}>
        <img src={getAssetUrl('ai-prompt-box-redesign-templates.webp')} alt="" className={styles.tooltipImage} />
        <Text val={window.i18next.t('pmwjs_redesign_templates')} className={styles.tooltipTitle} />
        <Text val={window.i18next.t('pmwjs_customise_templates_in_seconds_with_ai')} className={styles.tooltipSubtitle} />
      </div>
    </Popover>
  );
}
